<template>
  <b-container fluid class="p-0 mb-1 company-profile">
    <b-row no-gutters>
      <b-col cols="2"
        ><div><b-img class="company-logo" :src="companyInfo.logo" alt /></div
      ></b-col>
      <b-col cols="8"
        ><div class="p-2">
          <h2 class="company-name">
            {{ companyInfo.name }}
          </h2>
          <p class="company-address">{{ companyInfo.address }}</p>
        </div></b-col
      >
      <b-col cols="2"
        ><div class="pt-2"><b-button
          class="go-to-profile-btn"
          @click="
            $router.push({
              name: 'companyProfile',
              params: { companyId: $route.params.companyId },
            })
          "
          >profile</b-button
        ><div v-if="companyInfo.url !== userInfo.company" class="follow-box">
              <b-button
          v-if="!companyFollowStatus"
          class="other-profile-follow-btn"
          variant="info"
          @click="followReq"
          ><i class="far fa-eye"></i>
        </b-button>
        <b-button
          v-else
          class="other-profile-follow-btn"
          variant="info"
          @click="UnFollowReq"
        >
          <i class="far fa-eye-slash"></i>
        </b-button>
        </div>
      </div> </b-col
      ></b-row
    >
    <b-row class="mb-3 mt-3" v-if="companyInfo.tag_details && companyInfo.tag_details.length">
      <b-col>
        <div class="profile-segments-div">
          <b-badge
            v-for="segment in companyInfo.tag_details"
            :key="segment.id"
            class="profile-segment"
            variant="dark"
          >
            {{ segment.name }}
          </b-badge>
        </div>
      </b-col>
    </b-row>
    <notifications group="profile" position="bottom left" />
  </b-container>
</template>

<script>
import CompanyProfile from '../../utils/mixins/CompanyProfile';

export default {
  name: 'MobileCompanyProfile',
  mixins: [CompanyProfile],
};
</script>
<style scoped>
.company-profile {
  background: white;
   border-radius: 10px;
}
.company-logo {
  border-radius: 10px 0 0 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.profile-segments-div {
  padding: 10px;
  text-align: left;
  width: 100%;
  border-top: 1px solid #ebebeb;
}
.profile-segments-div > span {
  border-radius: 0 8px 8px 8px;
}
.profile-segment {
  margin: 5px;
  padding: 4px 8px;
  background-color: #aaaaaa;
  font-size: 12px;
  line-height: 1.17;
  letter-spacing: normal;
  font-family: Arial;
  text-align: left;
  color: white;
  font-weight: normal;
  border-radius: 0 10px 10px 10px;
}
.profile-follow-btn {
  background-color: #bd9d5f;
  color: white;
  font-size: 14px;
  text-align: center;
  border: 0;
  border-left: 1px solid white;
  box-shadow: none;
  min-height: 30px;
  min-width: 30px;
}
.profile-message-icon,
.profile-follow-icon {
  font-size: 13.5px;
}
.go-to-profile-btn {
  background-color: #f3f3f3;
  color: #7f7f7f;
  border-radius: 0 10px 10px 10px;
  height: 28px;
  border: none;
  padding: 2px 4px;
  font-family: Arial;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
}
.other-profile-follow-btn{
  border-radius: 0 10px 10px 10px;
  height: 28px;
  border: none;
  padding: 2px 4px;
  font-family: Arial;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  background-color: #bd9d5f;
  color: #fff;
}
.company-name {
  color: #333333;
  font-size: 20px;
  font-weight: bold;
  text-transform: capitalize;
  margin: 0;
}
.company-address {
  color: #bd9d5f;
}
.company-address, .company-type {
  font-size: 14px;
  margin-bottom: 0rem;
  padding-bottom: 15px;
  text-transform: capitalize;
  padding: 0;
}
.user-profile-hr {
  background: whitesmoke;
  margin: 0rem;
}
.Unfriend {
  background-color: #aaa !important;
}
.congratulationModal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.congratulationModal a,
.congratulationModal button {
  color: #bd9d5f;
  background-color: #fff;
  border: 1px solid #bd9d5f;
  padding: 3px 10px;
  margin-right: 10px;
}
.congratulationModal a:hover,
.congratulationModal button:hover {
  color: #fff;
  background-color: #bd9d5f;
  border: 1px solid #fff;
}
.follow-box{
    display: inline-block;
    margin-left: 1px;
}
</style>
